import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../utils/errorUtils";
import * as actions from "../slices/settings";

// --- Payment Integration Actions ---
export const getPaymentIntegration = () => async (dispatch) => {
  dispatch(actions.setLoadingPayment());
  try {
    const { data } = await axiosInstance.get("/payment-integration", {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS") {
      dispatch(actions.setPaymentIntegration(data.data));
    }
  } catch (error) {
    dispatch(actions.setErrorLoadingPayment(getErrorMessage(error)));
  }
};

export const updatePaymentIntegration = (payload) => async (dispatch) => {
  dispatch(actions.setLoadingUpdatePayment());
  try {
    const { data } = await axiosInstance.put("/payment-integration", payload, {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS") {
      toast.success(data.message || "Payment integration updated!");
      dispatch(actions.updatePaymentSuccess(data.data));
      dispatch(
        actions.setServerResponseStatus({
          operation: "update-payment",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(actions.setErrorUpdatingPayment(message));
  }
};

// --- Fiscal Integration Actions ---
export const getFiscalIntegration = () => async (dispatch) => {
  dispatch(actions.setLoadingFiscal());
  try {
    const { data } = await axiosInstance.get("/fiscal-integration", {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS") {
      dispatch(actions.setFiscalIntegration(data.data));
    }
  } catch (error) {
    dispatch(actions.setErrorLoadingFiscal(getErrorMessage(error)));
  }
};

export const updateFiscalIntegration = (payload) => async (dispatch) => {
  dispatch(actions.setLoadingUpdateFiscal());
  try {
    const { data } = await axiosInstance.put("/fiscal-integration", payload, {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS") {
      toast.success(data.message || "Fiscal configuration updated!");
      dispatch(actions.updateFiscalSuccess(data.data));
      dispatch(
        actions.setServerResponseStatus({
          operation: "update-fiscal",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(actions.setErrorUpdatingFiscal(message));
  }
};

export const resetSettingsServerStatus = () => (dispatch) => {
  dispatch(actions.setServerResponseStatus(null));
};
